import { call } from "redux-saga/effects";


let getUrlTpModule = null;
export function* getUrlTp({payload}) {
  if (!getUrlTpModule) {
    getUrlTpModule = yield call(() => import('./get-url-tp'));
  }
  //llamada a modulo
  yield call(getUrlTpModule.getUrlTp, {data: payload })
}
